import CustomNavbar from './CustomNavbar';

function Music() {
    return(
        <div className="App">
            <CustomNavbar />
        </div>
    );
}


export default Music;